const InViewportHelper = {
  check(el) {
    let bounding = el.getBoundingClientRect();
    let topLeftCheck = bounding.top >= 0 && bounding.left >= 0;
    let rightCheck = bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
    let bottomCheck = bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);

    return topLeftCheck && rightCheck && bottomCheck;
  },

  checkAny(el) {
    var rect = el.getBoundingClientRect();

    return (
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight)
    );
  }
}

export default InViewportHelper;